export default __webpack_public_path__ + "static/media/google authenticator.1655a367.png";